import axios from "axios";
import { useEffect, useRef, useState } from "react";

const Baner = () => {
  const [images, setImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [animClass, setAnimClass] = useState("opacity-100");
  const [schoolData, setSchoolData] = useState([]);
  const bannerRef = useRef(null);
  const lastScrollY = useRef(0);

  /* ================= FETCH IMAGE ================= */
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}api/gambardepan`)
      .then((res) => {
        setImages(res.data);
        // PENTING: langsung tampil saat pertama load
        setAnimClass("animate-slide-up opacity-100");
      })
      .catch((err) => console.error("Gagal mengambil gambar banner:", err));
  }, []);

  /* ================= FETCH Data sekolah ================= */
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}api/datasekolah/all`
        );
        setSchoolData(response.data);
      } catch (error) {
        console.error("Error fetching school data:", error);
      }
    };

    fetchData();
  }, []);

  /* ================= SCROLL + INTERSECTION ================= */
  useEffect(() => {
    const section = bannerRef.current;
    if (!section) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        const scrollDir = window.scrollY > lastScrollY.current ? "down" : "up";

        lastScrollY.current = window.scrollY;

        if (entry.isIntersecting) {
          setAnimClass(
            scrollDir === "down"
              ? "animate-slide-up opacity-100"
              : "animate-slide-down opacity-100"
          );
        } else {
          setAnimClass("opacity-0");
        }
      },
      { threshold: 0.25 }
    );

    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  /* ================= SLIDER ================= */
  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  if (!images.length) return null;

  const imageUrl = `${process.env.REACT_APP_API_URL}api/gambardepan/media/${images[currentIndex].gambar.filename}`;

  return (
    <>
      {/* ===== ANIMATION STYLE ===== */}
      <style>
        {`
        .animate-slide-up {
          animation: slideUp 0.8s ease forwards;
        }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(40px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .animate-slide-down {
          animation: slideDown 0.8s ease forwards;
        }
        @keyframes slideDown {
          from { opacity: 0; transform: translateY(-40px); }
          to { opacity: 1; transform: translateY(0); }
        }
        `}
      </style>

      <section
        ref={bannerRef}
        className={`mt-16 px-4 transition-all ${animClass}`}
      >
        <div className="relative max-w-6xl mx-auto h-64 md:h-80 lg:h-[420px] rounded-3xl overflow-hidden shadow-2xl">
          {/* ===== BLUR BACKGROUND ===== */}
          <img
            src={imageUrl}
            alt=""
            className="absolute inset-0 w-full h-full object-cover blur-xl scale-110"
          />

          {/* ===== OVERLAY ===== */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-transparent z-10" />

          {/* ===== MAIN IMAGE ===== */}
          <img
            src={imageUrl}
            alt="Kegiatan Sekolah"
            loading="lazy"
            decoding="async"
            className="relative z-20 mx-auto h-full object-contain"
          />

          {/* ===== TEXT ===== */}
          <div className="absolute bottom-6 left-6 right-6 z-30 text-white">
            {schoolData.map((q) => (
              <div key={q._id}>
                <h1 className="text-lg md:text-3xl font-bold drop-shadow">
                  Selamat Datang di {q.namasekolah}
                </h1>
              </div>
            ))}

            <p className="text-sm md:text-base text-white/90 mt-1">
              Sekolah Ramah Anak • Berkarakter • Berprestasi
            </p>
          </div>

          {/* ===== BUTTON PREV ===== */}
          <button
            onClick={prevSlide}
            className="absolute left-4 top-1/2 -translate-y-1/2 z-30
              bg-white/80 hover:bg-white text-gray-800
              p-2 rounded-full shadow-lg transition"
          >
            ❮
          </button>

          {/* ===== BUTTON NEXT ===== */}
          <button
            onClick={nextSlide}
            className="absolute right-4 top-1/2 -translate-y-1/2 z-30
              bg-white/80 hover:bg-white text-gray-800
              p-2 rounded-full shadow-lg transition"
          >
            ❯
          </button>
        </div>

        {/* ===== INDICATOR ===== */}
        <div className="flex justify-center gap-2 mt-4">
          {images.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`w-3 h-3 rounded-full transition
                ${
                  index === currentIndex
                    ? "bg-primary scale-125"
                    : "bg-gray-400"
                }`}
            />
          ))}
        </div>
      </section>
    </>
  );
};

export default Baner;
